"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Import;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Import(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "import"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,58.955a2.5,2.5,0,0,0-2.5,2.5v17.5h-75v-17.5a2.5,2.5,0,0,0-5,0v20a2.5,2.5,0,0,0,2.5,2.5H90a2.5,2.5,0,0,0,2.5-2.5v-20A2.5,2.5,0,0,0,90,58.955Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.912,65.085a2.955,2.955,0,0,0,4.176,0L72.34,44.834A2.5,2.5,0,0,0,68.805,41.3L52.5,57.6V18.545a2.5,2.5,0,0,0-5,0V57.6L31.2,41.3a2.5,2.5,0,0,0-3.535,3.535Z"
  })))));
}